import {Component, OnInit} from '@angular/core';
import {switchMap} from 'rxjs/operators';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {of} from 'rxjs';
import {SessionManagementService} from '../../../core/services/session-management.service';
import {MatTabChangeEvent} from '@angular/material/tabs';

@Component({
  selector: 'app-file-tab-group',
  templateUrl: './file-tab-group.component.html',
  styleUrls: ['./file-tab-group.component.scss']
})
export class FileTabGroupComponent implements OnInit {

  selectedTabIndex = 0;

  constructor(private route: ActivatedRoute, private sessionManagementService: SessionManagementService) {
  }

  ngOnInit() {
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        of(params.get('index'))
      )
    ).subscribe((index) => {
      this.selectedTabIndex = Number(index);
    });
  }

  tabChanged(event: MatTabChangeEvent) {
    this.sessionManagementService.extendSession();
  }

}
